module.exports = __webpack_public_path__ + "static/media/img16.5d2fc8ef.jpeg";